<template>
  <el-select
    size="small"
    filterable
    @change="handleChange"
    placeholder="请选择"
    :value="value"
    :popper-append-to-body="false"
  >
    <el-option :key="0" label="不限" :value="0" v-if="search"></el-option>
    <el-option-group
      :key="'group' + index"
      :label="group[0].group_name"
      v-for="(group, index) in groupList"
    >
      <el-option
        v-for="item in group"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      ></el-option>
    </el-option-group>
  </el-select>
</template>

<script>
import { serviceQuestFlowList } from '@/service/getData'

export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    search: {
      type: Boolean,
    },
  },
  data() {
    return {
      lists: [],
    }
  },
  created() {
    this.requestData()
  },
  computed: {
    groupList() {
      return this.groupBy(this.lists, function (item) {
        return [item.group_name]
      })
    },
  },
  mounted() {
    this.$nextTick(() => {
      Array.from(document.getElementsByClassName('el-select')).forEach(
        (item) => {
          item.children[0].children[0].removeAttribute('readOnly')
          item.children[0].children[0].onblur = function () {
            let _this = this
            setTimeout(() => {
              _this.removeAttribute('readOnly')
            }, 200)
          }
        }
      )
    })
  },
  methods: {
    async requestData() {
      let res = await serviceQuestFlowList()
      if (res.code == 0) {
        this.lists = res.data.list
      }
    },
    handleChange(val) {
      this.$emit('input', val)
      this.$emit('info', this.lists.filter((item) => item.id == val)[0])
    },
  },
}
</script>